import api from 'service/api'

const dponetAPIWithoutTrait = api.create('dponet', false)

const nameDpo = async ({
  token,
  companyDocument,
  governanceProjectTemplateStage,
}) => {
  return await dponetAPIWithoutTrait.post(
    `governance_project_templates/${token}/governance_project_company_stages/name_dpo`,
    { companyDocument, governanceProjectTemplateStage },
  )
}

const attachNomination = async ({
  token,
  companyDocument,
  attachNomination,
}) => {
  return await dponetAPIWithoutTrait.postForm(
    `governance_project_templates/${token}/governance_project_company_stages/attach_nomination`,
    { companyDocument, attachNomination },
  )
}

const sendToReview = async ({ token, companyDocument }) => {
  return await dponetAPIWithoutTrait.post(
    `governance_project_templates/${token}/governance_project_company_stages/send_to_review`,
    { companyDocument },
  )
}

export default {
  nameDpo,
  attachNomination,
  sendToReview,
}
